import ParametersFormatter from "../../../parametersFormatting/ParametersFormatter"
import {ReportChartType, ReportGroupingLevel} from "../../constants"
import messageResource from "../../../messageResource"
import BaseReportFormatUtils from '../../FormatUtils'

export default class ChartParametersFormatter extends ParametersFormatter {

    init({selectorsData, dateFormat, ugrFeatureEnabled, tzgFeatureEnabled, reportAuthorizationInfo, reportParamsStringBuilderConstructor}) {
        this.reportParamsStringBuilder = new reportParamsStringBuilderConstructor({
            data: {
                users: selectorsData.users,
                userGroupsFeatureEnabled: ugrFeatureEnabled,
                tzGroupsFeatureEnabled: tzgFeatureEnabled,
                userGroups: selectorsData.userGroups,
                timeZoneGroups: selectorsData.timeZoneGroups,
                cpList: selectorsData.customersProjects,
                leaveTypesMap: selectorsData.leaveTypesMap,
                statuses: selectorsData.statuses,
                manageableUserIds: selectorsData.manageableUserIds,
                projectsWithMaIds: selectorsData.projectsWithMaIds,
            },
            dateFormat: dateFormat,
            reportAuthorizationInfo: reportAuthorizationInfo,
            userFormatter: BaseReportFormatUtils.reportUserFormatterWithoutUsername,
        })
        return this
    }

    formatChartTypeValue(chartType)
    {
        var key;
        switch (chartType)
        {
            case ReportChartType.TOTAL_WORKING_HOURS:
                key = "report.chart_type.total_working_hours";
                break;
            case ReportChartType.APPROVED_WORKING_HOURS:
                key = "report.chart_type.approved_working_hours";
                break;
            case ReportChartType.LEAVE_HOURS:
                key = "report.chart_type.leave_hours";
                break;
            case ReportChartType.PTO_BALANCE:
                key = "report.chart_type.pto_balance";
                break;
            case ReportChartType.SICK_DAYS_BALANCE:
                key = "report.chart_type.sick_days_balance";
                break;
            case ReportChartType.OVERTIME_HOURS:
                key = "report.chart_type.overtime_hours";
                break;
            case ReportChartType.COST_OF_WORK:
                key = "report.chart_type.cost_of_work";
                break;
            case ReportChartType.BILLABLE_AMOUNTS:
                key = "report.chart_type.billable_amounts";
        }
        return messageResource.getMessage(key);
    }

    formatGroupingLevelValue(groupingLevel)
    {
        var key;
        switch (groupingLevel)
        {
            case ReportGroupingLevel.USER:
                key = "report.chart_pdf_preview.users";
                break;
            case ReportGroupingLevel.USER_GROUP:
                key = "common.user_groups";
                break;
            case ReportGroupingLevel.TIME_ZONE_GROUP:
                key = "common.time_zone_groups";
                break;
            case ReportGroupingLevel.CUSTOMER:
                key = "common.customers";
                break;
            case ReportGroupingLevel.PROJECT:
                key = "common.projects";
                break;
            case ReportGroupingLevel.BILLING_TYPE:
                key = "report.chart_pdf_preview.types_of_work";
                break;
            case ReportGroupingLevel.MONTH:
                key = "report.chart_pdf_preview.months";
                break;
            case ReportGroupingLevel.WEEK:
                key = "report.chart_pdf_preview.weeks";
                break;
            case ReportGroupingLevel.DATE:
                key = "report.chart_pdf_preview.days";
                break;
            case ReportGroupingLevel.LEAVE_TYPE:
                key = "report.chart_pdf_preview.leave_type";
                break;
        }
        return messageResource.getMessage(key);
    }

    getChartCategoryName(groupingLevel) {
        switch (groupingLevel) {
            case ReportGroupingLevel.USER:
                return messageResource.getMessage('common.User')
            case ReportGroupingLevel.USER_GROUP:
                return messageResource.getMessage('common.User_Group')
            case ReportGroupingLevel.TIME_ZONE_GROUP:
                return messageResource.getMessage('common.Time_Zone_Group')
            case ReportGroupingLevel.CUSTOMER:
                return messageResource.getMessage('common.Customer')
            case ReportGroupingLevel.PROJECT:
                return messageResource.getMessage('common.Project')
            case ReportGroupingLevel.LEAVE_TYPE:
                return messageResource.getMessage('report.common.leave_type')
            case ReportGroupingLevel.BILLING_TYPE:
                return messageResource.getMessage('report.common.billing_type')
            case ReportGroupingLevel.DATE:
                return messageResource.getMessage('common.date')
            case ReportGroupingLevel.WEEK:
                return messageResource.getMessage('common.week')
            case ReportGroupingLevel.MONTH:
                return messageResource.getMessage('common.month')
            default:
                return ''
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/ChartParametersFormatter.js